// extracted by mini-css-extract-plugin
export default {"content":"pOilf","align--left":"vdDWy","align--center":"cUJjo","align--right":"kqoCI"};